import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class RelationshipService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/relationships`, options);
  }
}

export default RelationshipService;
